<template>
  <div class="select-container">
    <v-select
      v-model="currentValue"
      :reduce="(option) => option.value"
      :clearable="false"
      :options="initialOptions"
      :searchable="false"
    >
    </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'appFilter',
  components: { vSelect },
  props: {
    value: { type: String, default: '', required: false, },
    initialOptions: {
      type: Array,
      default: () => {
        return []
      },
      required: false,
    },
  },

  data() {
    return {
    }
  },

  computed: {
    currentValue: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>
